(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-alberta-se"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.alberta-se-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: if "Back Garden Install" is active, add the install bundle
  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-alberta-se-form]',
      deliveryGroup: '[data-alberta-se-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-alberta-se-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-alberta-se-thumb]'));
  var indexLabel = root.querySelector('[data-alberta-se-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-alberta-se-prev]');
  var next = root.querySelector('[data-alberta-se-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-alberta-se-qty-dec]');
    var inc = qty.querySelector('[data-alberta-se-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-calgary"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.calgary-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: if "Back Garden Install" is active, add the install bundle
  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-calgary-form]',
      deliveryGroup: '[data-calgary-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-calgary-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-calgary-thumb]'));
  var indexLabel = root.querySelector('[data-calgary-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-calgary-prev]');
  var next = root.querySelector('[data-calgary-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-calgary-qty-dec]');
    var inc = qty.querySelector('[data-calgary-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-chill-therapy-brown"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.chill-therapy-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-ctherapy-form]',
      deliveryGroup: '[data-ctherapy-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-ctherapy-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ctherapy-thumb]'));
  var indexLabel = root.querySelector('[data-ctherapy-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-ctherapy-prev]');
  var next = root.querySelector('[data-ctherapy-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-ctherapy-qty-dec]');
    var inc = qty.querySelector('[data-ctherapy-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-chill-therapy-grey"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.chill-therapy-grey-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-ctgrey-form]',
      deliveryGroup: '[data-ctgrey-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-ctgrey-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ctgrey-thumb]'));
  var indexLabel = root.querySelector('[data-ctgrey-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-ctgrey-prev]');
  var next = root.querySelector('[data-ctgrey-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-ctgrey-qty-dec]');
    var inc = qty.querySelector('[data-ctgrey-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-chilliwack-sauna"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.chilliwack-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-chill-form]',
      deliveryGroup: '[data-chill-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-chill-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-chill-thumb]'));
  var indexLabel = root.querySelector('[data-chill-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-chill-prev]');
  var next = root.querySelector('[data-chill-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-chill-qty-dec]');
    var inc = qty.querySelector('[data-chill-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-complete-chemical-kit"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.chk-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-chk-form]',
      deliveryGroup: '[data-chk-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-chk-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-chk-thumb]'));
  var indexLabel = root.querySelector('[data-chk-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-chk-prev]');
  var next = root.querySelector('[data-chk-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-chk-qty-dec]');
    var inc = qty.querySelector('[data-chk-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-cornwall"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.cornwall-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: if "Back Garden Install" is active, add the install bundle
  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-cornwall-form]',
      deliveryGroup: '[data-cornwall-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-cornwall-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-cornwall-thumb]'));
  var indexLabel = root.querySelector('[data-cornwall-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-cornwall-prev]');
  var next = root.querySelector('[data-cornwall-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-cornwall-qty-dec]');
    var inc = qty.querySelector('[data-cornwall-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-erie-se"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.erie-se-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: if "Back Garden Install" is active, add the install bundle
  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-erie-se-form]',
      deliveryGroup: '[data-erie-se-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-erie-se-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-erie-se-thumb]'));
  var indexLabel = root.querySelector('[data-erie-se-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-erie-se-prev]');
  var next = root.querySelector('[data-erie-se-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-erie-se-qty-dec]');
    var inc = qty.querySelector('[data-erie-se-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ex-display-chilliwack-sauna"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.chilliwack-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-chill-form]',
      deliveryGroup: '[data-chill-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-chill-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-chill-thumb]'));
  var indexLabel = root.querySelector('[data-chill-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-chill-prev]');
  var next = root.querySelector('[data-chill-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-chill-qty-dec]');
    var inc = qty.querySelector('[data-chill-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-fraser-gazebo"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.fraser-gazebo-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-frgz-form]',
      deliveryGroup: '[data-frgz-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-frgz-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-frgz-thumb]'));
  var indexLabel = root.querySelector('[data-frgz-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-frgz-prev]');
  var next = root.querySelector('[data-frgz-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-frgz-qty-dec]');
    var inc = qty.querySelector('[data-frgz-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grand-rapids-2025"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.grand-rapids-2025-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-gr25-form]',
      deliveryGroup: '[data-gr25-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-gr25-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gr25-thumb]'));
  var indexLabel = root.querySelector('[data-gr25-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-gr25-prev]');
  var next = root.querySelector('[data-gr25-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-gr25-qty-dec]');
    var inc = qty.querySelector('[data-gr25-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grand-rapids"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.grand-rapids-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-grand-rapids-form]',
      deliveryGroup: '[data-grand-rapids-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-grand-rapids-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-grand-rapids-thumb]'));
  var indexLabel = root.querySelector('[data-grand-rapids-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-grand-rapids-prev]');
  var next = root.querySelector('[data-grand-rapids-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-grand-rapids-qty-dec]');
    var inc = qty.querySelector('[data-grand-rapids-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-kingston-se"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.kingston-se-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: if "Back Garden Install" is active, add the install bundle
  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-kingston-se-form]',
      deliveryGroup: '[data-kingston-se-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-kingston-se-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-kingston-se-thumb]'));
  var indexLabel = root.querySelector('[data-kingston-se-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-kingston-se-prev]');
  var next = root.querySelector('[data-kingston-se-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-kingston-se-qty-dec]');
    var inc = qty.querySelector('[data-kingston-se-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-london-se"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.london-se-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: if "Back Garden Install" is active, add the install bundle
  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-london-se-form]',
      deliveryGroup: '[data-london-se-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-london-se-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-london-se-thumb]'));
  var indexLabel = root.querySelector('[data-london-se-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-london-se-prev]');
  var next = root.querySelector('[data-london-se-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-london-se-qty-dec]');
    var inc = qty.querySelector('[data-london-se-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-manitoba"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.manitoba-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: if "Back Garden Install" is active, add the install bundle
  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-manitoba-form]',
      deliveryGroup: '[data-manitoba-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-manitoba-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-manitoba-thumb]'));
  var indexLabel = root.querySelector('[data-manitoba-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-manitoba-prev]');
  var next = root.querySelector('[data-manitoba-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-manitoba-qty-dec]');
    var inc = qty.querySelector('[data-manitoba-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-montreal"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.montreal-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: if "Back Garden Install" is active, add the install bundle
  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-montreal-form]',
      deliveryGroup: '[data-montreal-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-montreal-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-montreal-thumb]'));
  var indexLabel = root.querySelector('[data-montreal-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-montreal-prev]');
  var next = root.querySelector('[data-montreal-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-montreal-qty-dec]');
    var inc = qty.querySelector('[data-montreal-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-muskoka"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.muskoka-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: if "Back Garden Install" is active, add the install bundle
  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-muskoka-form]',
      deliveryGroup: '[data-muskoka-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-muskoka-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-muskoka-thumb]'));
  var indexLabel = root.querySelector('[data-muskoka-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-muskoka-prev]');
  var next = root.querySelector('[data-muskoka-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-muskoka-qty-dec]');
    var inc = qty.querySelector('[data-muskoka-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-niagara"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.niagara-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: if "Back Garden Install" is active, add the install bundle
  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-niagara-form]',
      deliveryGroup: '[data-niagara-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-niagara-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-niagara-thumb]'));
  var indexLabel = root.querySelector('[data-niagara-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-niagara-prev]');
  var next = root.querySelector('[data-niagara-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-niagara-qty-dec]');
    var inc = qty.querySelector('[data-niagara-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-okanagan"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.okanagan-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: if "Back Garden Install" is active, add the install bundle
  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-okanagan-form]',
      deliveryGroup: '[data-okanagan-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-okanagan-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-okanagan-thumb]'));
  var indexLabel = root.querySelector('[data-okanagan-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-okanagan-prev]');
  var next = root.querySelector('[data-okanagan-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-okanagan-qty-dec]');
    var inc = qty.querySelector('[data-okanagan-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-outdoor-barrel-sauna"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.outdoor-barrel-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-barrel-form]',
      deliveryGroup: '[data-barrel-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-barrel-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-barrel-thumb]'));
  var indexLabel = root.querySelector('[data-barrel-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-barrel-prev]');
  var next = root.querySelector('[data-barrel-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-barrel-qty-dec]');
    var inc = qty.querySelector('[data-barrel-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-st-lawrence-13"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.st-lawrence-13-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: if "Back Garden Install" is active, add the install bundle
  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-st-lawrence-13-form]',
      deliveryGroup: '[data-st-lawrence-13-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-st-lawrence-13-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-st-lawrence-13-thumb]'));
  var indexLabel = root.querySelector('[data-st-lawrence-13-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-st-lawrence-13-prev]');
  var next = root.querySelector('[data-st-lawrence-13-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-st-lawrence-13-qty-dec]');
    var inc = qty.querySelector('[data-st-lawrence-13-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-st-lawrence-16"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.st-lawrence-16-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: if "Back Garden Install" is active, add the install bundle
  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-st-lawrence-16-form]',
      deliveryGroup: '[data-st-lawrence-16-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-st-lawrence-16-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-st-lawrence-16-thumb]'));
  var indexLabel = root.querySelector('[data-st-lawrence-16-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-st-lawrence-16-prev]');
  var next = root.querySelector('[data-st-lawrence-16-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-st-lawrence-16-qty-dec]');
    var inc = qty.querySelector('[data-st-lawrence-16-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-st-lawrence-20"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.st-lawrence-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: if "Back Garden Install" is active, add the install bundle
  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-st-lawrence-20-form]',
      deliveryGroup: '[data-st-lawrence-20-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-st-lawrence-20-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-st-lawrence-20-thumb]'));
  var indexLabel = root.querySelector('[data-st-lawrence-20-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-st-lawrence-20-prev]');
  var next = root.querySelector('[data-st-lawrence-20-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-st-lawrence-20-qty-dec]');
    var inc = qty.querySelector('[data-st-lawrence-20-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-thunder-bay"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.thunder-bay-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: if "Back Garden Install" is active, add the install bundle
  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-thunder-bay-form]',
      deliveryGroup: '[data-thunder-bay-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-thunder-bay-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thunder-bay-thumb]'));
  var indexLabel = root.querySelector('[data-thunder-bay-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-thunder-bay-prev]');
  var next = root.querySelector('[data-thunder-bay-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-thunder-bay-qty-dec]');
    var inc = qty.querySelector('[data-thunder-bay-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-toronto-uv"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.toronto-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: if "Back Garden Install" is active, add the install bundle
  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-toronto-form]',
      deliveryGroup: '[data-toronto-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-toronto-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-toronto-thumb]'));
  var indexLabel = root.querySelector('[data-toronto-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-toronto-prev]');
  var next = root.querySelector('[data-toronto-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-toronto-qty-dec]');
    var inc = qty.querySelector('[data-toronto-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tremblant-sauna"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.tremblant-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-trem-form]',
      deliveryGroup: '[data-trem-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-trem-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-trem-thumb]'));
  var indexLabel = root.querySelector('[data-trem-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-trem-prev]');
  var next = root.querySelector('[data-trem-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-trem-qty-dec]');
    var inc = qty.querySelector('[data-trem-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-vancouver-uv"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.vancouver-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: if "Back Garden Install" is active, add the install bundle
  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-vancouver-form]',
      deliveryGroup: '[data-vancouver-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-vancouver-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-vancouver-thumb]'));
  var indexLabel = root.querySelector('[data-vancouver-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-vancouver-prev]');
  var next = root.querySelector('[data-vancouver-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-vancouver-qty-dec]');
    var inc = qty.querySelector('[data-vancouver-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-victoria"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.victoria-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: if "Back Garden Install" is active, add the install bundle
  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-victoria-form]',
      deliveryGroup: '[data-victoria-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-victoria-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-victoria-thumb]'));
  var indexLabel = root.querySelector('[data-victoria-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-victoria-prev]');
  var next = root.querySelector('[data-victoria-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-victoria-qty-dec]');
    var inc = qty.querySelector('[data-victoria-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-winnipeg-uv"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.winnipeg-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: if "Back Garden Install" is active, add the install bundle
  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-winnipeg-form]',
      deliveryGroup: '[data-winnipeg-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-winnipeg-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-winnipeg-thumb]'));
  var indexLabel = root.querySelector('[data-winnipeg-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-winnipeg-prev]');
  var next = root.querySelector('[data-winnipeg-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-winnipeg-qty-dec]');
    var inc = qty.querySelector('[data-winnipeg-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-yukon"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.yukon-pdp');
  if (!root) return;

  // Delivery/install chip selection
  root.querySelectorAll('.option-chips').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chip');
      if (!btn) return;
      group.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  // Add-to-cart: if "Back Garden Install" is active, add the install bundle
  // Add-to-cart: AJAX via shared helper (assets/csc-pdp-cart.js).
  // Disables button + shows "Adding…", refreshes the Dawn cart drawer,
  // opens it, and shows an inline red error on failure.
  if (window.CscPdpCart) {
    window.CscPdpCart.attach({
      root: root,
      form: '[data-yukon-form]',
      deliveryGroup: '[data-yukon-delivery]'
    });
  }

  // Gallery — click thumb to swap main image
  var mainImg = root.querySelector('[data-yukon-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-yukon-thumb]'));
  var indexLabel = root.querySelector('[data-yukon-index]');
  var currentIndex = 0;

  function activate(i) {
    if (!thumbs.length) return;
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    currentIndex = i;
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    var t = thumbs[i];
    t.classList.add('active');
    if (mainImg) {
      var url = t.getAttribute('data-image-url');
      var alt = t.getAttribute('data-alt') || '';
      if (url) mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }
    if (indexLabel) {
      var n = (i + 1).toString();
      indexLabel.textContent = n.length < 2 ? '0' + n : n;
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { activate(i); });
  });

  var prev = root.querySelector('[data-yukon-prev]');
  var next = root.querySelector('[data-yukon-next]');
  if (prev) prev.addEventListener('click', function () { activate(currentIndex - 1); });
  if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });

  // Quantity +/-
  var qty = root.querySelector('.qty');
  if (qty) {
    var input = qty.querySelector('input');
    var dec = qty.querySelector('[data-yukon-qty-dec]');
    var inc = qty.querySelector('[data-yukon-qty-inc]');
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, v - 1);
    });
    if (inc) inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
